import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import useRepo from '@/nebula/repo';
import { hubspotQuery as hubspotQueryConfig } from 'shared/api/query/configs.json';

export default function useHubspot() {
  const queryRepo = useRepo(hubspotQueryConfig.model);

  const { loggedInUser } = useLoggedInUser();

  const createQuery = (entity) => queryRepo.createSingle({
    ...entity,
    creator: { uid: loggedInUser.value.uid },
  });

  return {
    createQueryLoading: queryRepo.createLoading,
    createQuery,
    updateQueryLoading: queryRepo.updateLoading,
    updateQuery: (entity) => queryRepo.updateSingle(entity, { ignoreResponse: false }),
    deleteQueryLoading: queryRepo.deleteLoading,
    deleteQuery: queryRepo.deleteSingle,
  };
}
